import { render } from "./search-form-header.vue?vue&type=template&id=4dabf020"
import script from "./search-form-header.vue?vue&type=script&lang=js"
export * from "./search-form-header.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__